/**
 * Ícones do menu, portados literalmente do protótipo
 * (`prototipo/Mandato360-prototipo-identidade_3.html`, array `ROUTES`,
 * proto:509-535, com a substituição do grupo OTO em proto:1562-1564).
 *
 * O protótipo desenha cada ícone em `viewBox="0 0 24 24"` com
 * `stroke-width="2"`. Os paths abaixo são transcrição literal das strings
 * `ic:` do protótipo — não reformatar, não reordenar atributos.
 */

export type IconeRota =
  | 'dash'
  | 'notif'
  | 'contatos'
  | 'liderancas'
  | 'datas'
  | 'solic'
  | 'agenda'
  | 'visitas'
  | 'acoes'
  | 'emendas'
  | 'reguas'
  | 'perfil'
  | 'fontes'
  | 'estrategias'
  | 'agentes'
  | 'eleg'
  | 'terr'
  | 'campanhas'
  | 'eleg-cand'
  | 'controle'
  | 'matriz'
  | 'eleg-bn'
  | 'pesquisas'
  | 'falando'
  | 'alertas'
  | 'agente'
  | 'eleg-ing'
  | 'admin'
  | 'config'
  | 'audit'
  | 'outbox';

export const ICONES: Record<IconeRota, string> = {
  dash: '<rect x="3" y="3" width="8" height="8" rx="2"/><rect x="13" y="3" width="8" height="8" rx="2"/><rect x="3" y="13" width="8" height="8" rx="2"/><rect x="13" y="13" width="8" height="8" rx="2"/>',
  notif: '<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10 21a2 2 0 0 0 4 0"/>',
  contatos: '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>',
  liderancas: '<circle cx="9" cy="7" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M2 21a7 7 0 0 1 14 0M15 21a5 5 0 0 1 7-4"/>',
  datas: '<path d="M12 3v4M8 7h8l1 4H7zM5 11h14v10H5z"/>',
  solic: '<path d="M9 5h6M9 3h6v4H9zM5 7h14v14H5z"/><path d="M9 13l2 2 4-4"/>',
  agenda: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
  visitas: '<path d="M3 21h18M5 21V8l7-5 7 5v13"/><path d="M9 21v-5h6v5"/>',
  acoes: '<path d="M4 12l5 5L20 6"/>',
  emendas: '<path d="M4 20h16M6 20V9l6-5 6 5v11"/><path d="M10 20v-6h4v6"/>',
  reguas: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/>',
  perfil: '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/><path d="M17 3l1 2 2 1-2 1-1 2-1-2-2-1 2-1z"/>',
  fontes: '<path d="M4 4h10l6 6v10H4z"/><path d="M14 4v6h6M8 14h8M8 18h5"/>',
  estrategias: '<path d="M3 17l6-6 4 4 8-8"/><circle cx="21" cy="7" r="2"/>',
  agentes: '<rect x="4" y="6" width="16" height="12" rx="3"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><path d="M12 3v3"/>',
  eleg: '<path d="M3 17l6-6 4 4 8-8"/><path d="M14 7h7v7"/>',
  terr: '<path d="M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  campanhas: '<path d="M21 12a9 9 0 0 1-13.5 7.8L3 21l1.2-4.5A9 9 0 1 1 21 12z"/>',
  'eleg-cand': '<path d="M4 19V5M4 19h16"/><rect x="7" y="10" width="3" height="9"/><rect x="12" y="6" width="3" height="13"/><rect x="17" y="13" width="3" height="6"/>',
  controle: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/>',
  matriz: '<path d="M3 3v18h18"/><circle cx="9" cy="14" r="2"/><circle cx="15" cy="8" r="2.5"/><circle cx="17" cy="15" r="1.5"/>',
  'eleg-bn': '<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 8l8 8M16 8l-8 8"/>',
  pesquisas: '<path d="M4 20V10M10 20V4M16 20v-8M22 20H2"/>',
  falando: '<path d="M4 4h16v11H8l-4 4z"/><path d="M8 8h8M8 11h5"/>',
  alertas: '<path d="M12 3l10 18H2z"/><path d="M12 10v4M12 17v1"/>',
  agente: '<rect x="4" y="6" width="16" height="12" rx="3"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><path d="M12 3v3"/>',
  'eleg-ing': '<ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5"/><path d="M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3"/>',
  admin: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2"/>',
  config: '<path d="M12 2l3 6 6 1-4.5 4 1 6-5.5-3-5.5 3 1-6L3 9l6-1z"/>',
  audit: '<path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z"/><path d="M9 12l2 2 4-4"/>',
  outbox: '<path d="M4 4h16v16H4z"/><path d="M4 14h4l2 3h4l2-3h4"/>',
};

export function Icone({ nome }: { nome: IconeRota }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: ICONES[nome] }}
    />
  );
}
